import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLegalInfo, selectLegalInfoPage } from 'store/slices/AdditionalPagesSlice';
import AdditionalPage from 'pages/AdditionalPage';

const LegalInfo = () => {
    const dispatch = useDispatch();

    const { fs_title, fs_background, fs_button, blocks = [] } = useSelector(selectLegalInfoPage);

    const contentData = blocks.map(item => ({ block: item }));

    React.useEffect(() => {
        // @ts-ignore
        dispatch(fetchLegalInfo());
    }, [dispatch]);

    return (
        <AdditionalPage
            title={fs_title}
            background={fs_background}
            buttonText={fs_button}
            pageContentData={contentData}
        />
    );
};

export default LegalInfo;
